import { MutableRefObject } from "react";
import FileHandler from "@tiptap/extension-file-handler";

export const DEFAULT_ALLOWED_MIME_TYPES: `image/${string}`[] = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];

const imageSrcsToContent = (srcs: string[]) =>
  srcs.flatMap((src, i) => [
    { type: "image", attrs: { src } },
    ...(i < srcs.length - 1 ? [{ type: "paragraph" }] : []),
  ]);

export const createImageUploadExtension = (
  onImageUploadRef: MutableRefObject<
    ((files: File[], onComplete: (srcs: string[]) => void) => void) | undefined
  >,
  allowedMimeTypes: `image/${string}`[] = DEFAULT_ALLOWED_MIME_TYPES,
) => {
  return FileHandler.configure({
    allowedMimeTypes,
    onPaste: (editor, files) => {
      const upload = onImageUploadRef.current;
      if (!upload) return;
      upload(files, (srcs) => {
        editor.chain().focus().insertContent(imageSrcsToContent(srcs)).run();
      });
    },
    onDrop: (editor, files, pos) => {
      const upload = onImageUploadRef.current;
      if (!upload) return;
      upload(files, (srcs) => {
        editor
          .chain()
          .focus()
          .insertContentAt(pos, imageSrcsToContent(srcs))
          .run();
      });
    },
  });
};
